var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.68333L9.325 11.5083L13.3333 7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 17.0997L9.99998 17.5747L9.16665 17.0997C7.3924 16.0753 5.91918 14.6018 4.89517 12.8274C3.87117 11.0529 3.33249 9.04009 3.33331 6.99136C3.33361 6.69909 3.41077 6.41204 3.55703 6.159C3.7033 5.90596 3.91353 5.69583 4.16665 5.54969L9.23331 2.62469C9.46613 2.4893 9.73065 2.41797 9.99998 2.41797C10.2693 2.41797 10.5338 2.4893 10.7666 2.62469L15.8333 5.54969C16.0864 5.69583 16.2967 5.90596 16.4429 6.159C16.5892 6.41204 16.6663 6.69909 16.6666 6.99136C16.6675 9.04009 16.1288 11.0529 15.1048 12.8274C14.0808 14.6018 12.6076 16.0753 10.8333 17.0997Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibility);
export default __webpack_public_path__ + "static/media/Eligibility.e0507d33895c56f15b2c06612987af73.svg";
export { ForwardRef as ReactComponent };